import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createJob, editJob, getJobs, removeJob } from './jobsApi';

const initialState = {
    jobs: [],
    isLoading: false,
    isError: false,
    error: "",

    isDelete: false
};

// async thunk
export const fetchJobs = createAsyncThunk("jobs/fetchJobs", async () => {
    const jobs = await getJobs();
    return jobs;
});

export const addJob = createAsyncThunk("jobs/addJob", async (obj) => {
    const job = await createJob(obj);
    return job;
});

export const updateJob = createAsyncThunk("jobs/updateJob", async (obj) => {
    const job = await editJob(obj);
    return job;
});

export const deleteJob = createAsyncThunk("jobs/deleteJob", async (id) => {
    const job = await removeJob(id);
    return job;
});

export const jobsSlice = createSlice({
    name: 'jobs',
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchJobs.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(fetchJobs.fulfilled, (state, action) => {
                state.isLoading = false;
                state.jobs = action.payload;
            })
            .addCase(fetchJobs.rejected, (state, action) => {
                state.isLoading = false;
                state.jobs = [];
                state.isError = true;
                state.error = action.error?.message;
            })


            .addCase(deleteJob.pending, (state) => {
                state.isDelete = false
            })
            .addCase(deleteJob.fulfilled, (state, action) => {
                state.isDelete = true
            })
    },
});

export const { } = jobsSlice.actions;
export default jobsSlice.reducer;
